import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "../components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "../components/ui/tabs";
import { PageHeader, Empty } from "../components/common";
import { MissionCard } from "../components/MissionCard";
import { MissionFormDialog } from "../components/MissionFormDialog";
import { useData } from "../context/DataContext";
import { STATUTS_MISSION, nextDeadline } from "../lib/constants";

export default function Missions() {
  const { missions } = useData();
  const [tab, setTab] = useState("en_cours");
  const [dlg, setDlg] = useState({ open: false, item: null });
  const key = (m) => nextDeadline(m)?.echeance || "9999";
  const list = missions.filter((m) => tab === "all" || m.statut === tab).sort((a, b) => key(a).localeCompare(key(b)));

  return (
    <div data-testid="missions-page">
      <PageHeader eyebrow="Production" title="Missions" description="Suivi des missions clients, de leurs livrables et de la prochaine échéance."
        actions={<Button className="kc-btn-primary" onClick={() => setDlg({ open: true, item: null })} data-testid="missions-new-button"><Plus className="mr-1 h-4 w-4" />Nouvelle mission</Button>} />
      <Tabs value={tab} onValueChange={setTab} className="mb-8">
        <TabsList className="bg-[var(--kc-sand)]">
          {STATUTS_MISSION.map((s) => (
            <TabsTrigger key={s.id} value={s.id} data-testid={`missions-tab-${s.id}`}>{s.label} ({missions.filter((m) => m.statut === s.id).length})</TabsTrigger>
          ))}
          <TabsTrigger value="all" data-testid="missions-tab-all">Toutes</TabsTrigger>
        </TabsList>
      </Tabs>
      <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3">
        {list.map((m) => <MissionCard key={m.id} mission={m} onEdit={(item) => setDlg({ open: true, item })} />)}
      </div>
      {!list.length && <Empty>Aucune mission dans cette catégorie.</Empty>}
      <MissionFormDialog open={dlg.open} onOpenChange={(o) => setDlg((s) => ({ ...s, open: o }))} initial={dlg.item} />
    </div>
  );
}
